let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3Hzot")).then(() => parcelRequire('8Yee7'));